import { render, staticRenderFns } from "./test.vue?vue&type=template&id=5a908b40&scoped=true"
import script from "./test.vue?vue&type=script&lang=js"
export * from "./test.vue?vue&type=script&lang=js"
import style0 from "./test.vue?vue&type=style&index=0&id=5a908b40&prod&lang=scss&scoped=true"
import style1 from "./test.vue?vue&type=style&index=1&id=5a908b40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a908b40",
  null
  
)

export default component.exports